import { useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

export default function MaintenanceBanner() {
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('maintenance-banner-dismissed') === 'true');

  const dismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('maintenance-banner-dismissed', 'true');
  };

  if (dismissed) return null;

  return (
    <div
      role="alert"
      className="sticky top-0 z-[60] flex items-center justify-between gap-3 bg-amber-50 border-b border-amber-300 px-4 py-2 text-sm text-amber-900"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span>
          <strong>Maintenance mode is active.</strong> The public storefront is offline. Only admins can view the site.
        </span>
      </div>
      <button
        onClick={dismiss}
        className="shrink-0 p-1 rounded hover:bg-amber-200 transition-colors"
        aria-label="Dismiss maintenance banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
